<script lang="ts">
  import { type JSONObject } from "../lib/dataform/dataFormLib.svelte";
  import RailsForm from "../components/Form.svelte";
  import DataForm from "../lib/dataform/DataForm.svelte";
  import Workflow from "../lib/workflow/Workflow.svelte";
  import Step from "../lib/workflow/Step.svelte";
  import FinanceCompanyName from "./IdentifyFinanceCompanyTask/FinanceCompanyName.svelte";
  import ConsentStep from "./IdentifyFinanceCompanyTask/ConsentStep.svelte";
  import FinancingAddresses from "./IdentifyFinanceCompanyTask/FinancingAddresses.svelte";
  import HowToFindName from "./IdentifyFinanceCompanyTask/HowToFindName.svelte";

  let {
    action,
    data: serverData,
    errors,
    financeCompanyOptions,
    offerCreditCheck,
    checkboardLogo,
    kountLogo,
  }: {
    action: string;
    data: JSONObject;
    errors: { [key: string]: string } | undefined;
    financeCompanyOptions: string[];
    offerCreditCheck: boolean;
    checkboardLogo: string;
    kountLogo: string;
  } = $props();

  // svelte-ignore state_referenced_locally
  let data = $state({...serverData});

  let financeCompanyKnown = $state("yes");
</script>

<RailsForm method="put" {action} class="ui-rhythm">
  <DataForm {data} {errors}>
    <Workflow>
      <Step><FinanceCompanyName bind:selectedOption={financeCompanyKnown} {financeCompanyOptions} {errors} /></Step>
      <Step disabled={!offerCreditCheck}><ConsentStep {checkboardLogo} {kountLogo} /></Step>
      <Step disabled={!offerCreditCheck || data.credit_check_consent !== "Consented"}><FinancingAddresses /></Step>
      <Step><HowToFindName /></Step>
    </Workflow>
  </DataForm>
</RailsForm>
